/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireQuestion } from './CustomQuestionnaireQuestion';
import {
  CustomQuestionnaireQuestionFromJSON,
  CustomQuestionnaireQuestionFromJSONTyped,
  CustomQuestionnaireQuestionToJSON,
} from './CustomQuestionnaireQuestion';

/**
 * Adds nested create feature
 * @export
 * @interface CustomQuestionnaireStep
 */
export interface CustomQuestionnaireStep {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireStep
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireStep
   */
  order?: number;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireStep
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireStep
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireStep
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireStep
   */
  category?: string | null;
  /**
   *
   * @type {Array<CustomQuestionnaireQuestion>}
   * @memberof CustomQuestionnaireStep
   */
  questions: Array<CustomQuestionnaireQuestion>;
}

/**
 * Check if a given object implements the CustomQuestionnaireStep interface.
 */
export function instanceOfCustomQuestionnaireStep(value: object): value is CustomQuestionnaireStep {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('title' in value) || value['title'] === undefined) return false;
  if (!('questions' in value) || value['questions'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireStepFromJSON(json: any): CustomQuestionnaireStep {
  return CustomQuestionnaireStepFromJSONTyped(json, false);
}

export function CustomQuestionnaireStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomQuestionnaireStep {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    order: json['order'] == null ? undefined : json['order'],
    name: json['name'],
    title: json['title'],
    description: json['description'] == null ? undefined : json['description'],
    category: json['category'] == null ? undefined : json['category'],
    questions: (json['questions'] as Array<any>).map(CustomQuestionnaireQuestionFromJSON),
  };
}

export function CustomQuestionnaireStepToJSON(value?: Omit<CustomQuestionnaireStep, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    order: value['order'],
    name: value['name'],
    title: value['title'],
    description: value['description'],
    category: value['category'],
    questions: (value['questions'] as Array<any>).map(CustomQuestionnaireQuestionToJSON),
  };
}
